import {
  UPDATE_PASSWORD_FORM
} from "../types";

// Change Password
export function updateChangePasswordForm(data) {
  return { type: UPDATE_PASSWORD_FORM, payload: data };
}